import Vue from 'vue'
import store from '@/store'
import {ActionTree, MutationTree} from 'vuex'
import {RootState} from '@/store/types'
import i18n from "@/helpers/i18n";
import VueI18n from "@/helpers/i18n";

export interface State {
    sidebarDialogShow: Boolean,
    showDialog: Boolean,
    formDialog: String,
    formSidebarDialog: String,
    options: any,
    titleDialog: string,
    subtitleDialog: string,
    fullDialogShow: boolean,

    fullErrorShow: boolean,
    titleError: string,
    subtitleError: string,
    textContentError: string,
    isCopyError: boolean,
    isBtnLogout: boolean,
    isBtnSupport: boolean,
    isBtnHome:boolean,

    fullPlanShow: boolean,

    modalErrorShow: boolean,
    modalErrorTitle: string,
    modalErrorCopyText:string,

    supportDialogShow:boolean,
    supportDialogOption:string,
    supportDialogTitle:any,
    supportDialogSubtitle:any,

    topAlertShow:boolean,

    modalSupportShow: boolean,
    questionsModalShow: boolean,
}

const defaultState: State = {
    sidebarDialogShow: false,
    showDialog: false,
    formDialog: 'lfs-forms-none-form',
    formSidebarDialog: 'lfs-filters-filters-index',
    options: null,
    titleDialog: '',
    subtitleDialog: '',
    fullDialogShow: false,

    fullErrorShow: false,
    titleError: '',
    subtitleError: '',
    textContentError: '',
    isCopyError: false,
    isBtnLogout: false,
    isBtnSupport: false,
    isBtnHome:false,

    fullPlanShow: false,

    modalErrorShow: false,
    modalErrorTitle: '',
    modalErrorCopyText: '',

    supportDialogShow:false,
    supportDialogTitle:i18n.t('support.dialog.title'),
    supportDialogSubtitle:i18n.t('support.dialog.text'),
    supportDialogOption:'error_by_user',

    topAlertShow: false,
    modalSupportShow: false,
    questionsModalShow: false,
}

const getters = {
    supportDialogTitle:(state:State)=>state.supportDialogTitle,
    supportDialogSubtitle:(state:State)=>state.supportDialogSubtitle,
    supportDialogShow:(state:State)=>state.supportDialogShow,
    supportDialogOption:(state:State)=>state.supportDialogOption,
    fullDialogShow: (state: State) => state.fullDialogShow,
    sidebarDialogShow: (state: State) => state.sidebarDialogShow,
    titleDialog: (state: State) => state.titleDialog,
    subtitleDialog: (state: State) => state.subtitleDialog,
    formDialog: (state: State) => state.formDialog,
    formSidebarDialog: (state: State) => state.formSidebarDialog,
    GetSidebarDialogShow(state: State) {
        return state.sidebarDialogShow
    },
    GetFormSidebarDialog(state: State) {
        return state.formSidebarDialog
    },

    fullErrorShow: (state: State) => state.fullErrorShow,
    titleError: (state: State) => state.titleError,
    subtitleError: (state: State) => state.subtitleError,
    textContentError: (state: State) => state.textContentError,
    isCopyError: (state: State) => state.isCopyError,
    isBtnLogout: (state: State) => state.isBtnLogout,
    isBtnSupport: (state: State) => state.isBtnSupport,
    isBtnHome: (state: State) => state.isBtnHome,

    fullPlanShow: (state: State) => state.fullPlanShow,

    modalErrorShow: (state: State) => state.modalErrorShow,
    modalErrorTitle: (state: State) => state.modalErrorTitle,
    modalErrorCopyText: (state: State) => state.modalErrorCopyText,
    
    topAlertShow: (state: State) => state.topAlertShow,
    modalSupportShow: (state: State) => state.modalSupportShow,
    questionsModalShow: (state: State) => state.questionsModalShow,
    
}

const mutations: MutationTree<State> = {
    setSupportDialogSubtitle(state:State, payload:any){
        state.supportDialogSubtitle = payload
    },
    setSupportDialogTitle(state:State, payload:any){
        state.supportDialogTitle = payload
    },
    setSupportDialog(state:State, payload:boolean){

        state.supportDialogShow = payload
    },
    SetSidebarDialogShow(state: State, payload: Boolean) {
        state.sidebarDialogShow = payload
    },
    SetFormSidebarDialog(state: State, payload: String) {
        state.formSidebarDialog = payload
    },
    SetFullDialogShow(state: State, payload: any) {
        state.fullDialogShow = payload
    },
    SetTitleDialog(state: State, payload: string) {
        state.titleDialog = payload
    },
    SetSubtitleDialog(state: State, payload: string) {
        state.subtitleDialog = payload
    },
    SetFormSDialog(state: State, payload: string) {
        state.formDialog = payload
    },
    SetFullErrorShow(state: State, payload: boolean) {
        state.fullErrorShow = payload
    },
    SetTitleError(state: State, payload: string) {
        state.titleError = payload
    },
    SetSubtitleError(state: State, payload: string) {
        state.subtitleError = payload
    },
    SetTextContentError(state: State, payload: string) {
        state.textContentError = payload
    },
    SetIsCopyError(state: State, payload: boolean) {
        state.isCopyError = payload
    },
    SetIsBtnLogout(state: State, payload: boolean) {
        state.isBtnLogout = payload
    },
    SetIsBtnSupport(state: State, payload: boolean) {
        state.isBtnSupport = payload
    },
    setSupportDialogOption(state: State, payload: string) {
        state.supportDialogOption = payload
    },
    SetFullError(state: State, payload: any) {
        state.fullErrorShow = payload.fullErrorShow || true
        state.titleError = payload.titleError || ''
        state.subtitleError = payload.subtitleError || ''
        state.textContentError = payload.textContentError || ''
        state.isCopyError = payload.isCopyError || false
        state.isBtnLogout = payload.isBtnLogout || false
        state.isBtnSupport = payload.isBtnSupport || false
        state.isBtnHome = payload.isBtnHome || false
    },
    SetFullPlanShow(state: State, payload: boolean) {
        state.fullPlanShow = payload
    },
    SetModalError(state: State, payload: any) {
        state.modalErrorShow = payload.show
        state.modalErrorTitle = payload.modalErrorTitle
        state.modalErrorCopyText = payload.copyText
    },
    SetTopAlert(state: State, payload: boolean) {
        state.topAlertShow = payload
    },
    SetModalSupportShow(state: State, payload: boolean) {
        state.modalSupportShow = payload
    },
    SetQuestionsModalShow(state: State, payload: boolean) {
        state.questionsModalShow = payload
    },
}

const actions: ActionTree<State, RootState> = {}

export default {
    namespaced: true,
    state: defaultState,
    getters,
    mutations,
    actions,
};
